// extracted by mini-css-extract-plugin
export default {"summary":"mealsummry_summary__lGhv5"};